/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1FrequencyConfig } from '../models/V1FrequencyConfig';
import { V1ScheduleFrequency } from '../models/V1ScheduleFrequency';
import { V1ScheduleStatus } from '../models/V1ScheduleStatus';
import { HttpFile } from '../http/http';

/**
* A recurring delivery configuration for a Report. Schedules are sub-resources owned by a Report. Status transitions between ACTIVE and INACTIVE go through PauseSchedules and PlaySchedules; lifecycle transitions (SCHEDULED to ACTIVE to FINISHED) happen automatically.
*/
export class V1Schedule {
    /**
    * Server-assigned schedule identifier.
    */
    'id'?: string;
    /**
    * Owning organization.
    */
    'orgId'?: string;
    /**
    * The report this schedule belongs to.
    */
    'reportId'?: string;
    'status'?: V1ScheduleStatus;
    'frequency'?: V1ScheduleFrequency;
    /**
    * First run window start. On UpdateSchedule, the new value must be today or a future date.
    */
    'start': Date;
    /**
    * Last run window end. If provided, must be on or after start. On UpdateSchedule, the new value must be today or a future date. If end is NULL it will run indefinitely until paused or deleted.
    */
    'end'?: Date;
    /**
    * Email recipients. At least one required. Each must be a valid email address.
    */
    'recipients': Array<string>;
    'frequencyConfig'?: V1FrequencyConfig;
    /**
    * Server-assigned creation time.
    */
    'createTime'?: Date;
    /**
    * Server-assigned last-update time.
    */
    'updateTime'?: Date;
    /**
    * Set when the resource has been deleted; null otherwise.
    */
    'deleteTime'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "reportId",
            "baseName": "report_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "V1ScheduleStatus",
            "format": ""
        },
        {
            "name": "frequency",
            "baseName": "frequency",
            "type": "V1ScheduleFrequency",
            "format": ""
        },
        {
            "name": "start",
            "baseName": "start",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "end",
            "baseName": "end",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "recipients",
            "baseName": "recipients",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "frequencyConfig",
            "baseName": "frequency_config",
            "type": "V1FrequencyConfig",
            "format": ""
        },
        {
            "name": "createTime",
            "baseName": "create_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "updateTime",
            "baseName": "update_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "deleteTime",
            "baseName": "delete_time",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return V1Schedule.attributeTypeMap;
    }

    public constructor() {
    }
}

